export enum ResponseErrorCodes {
    INVALID_TOKEN = 'INVALID_TOKEN',
    SIMULTANEOUS_SESSIONS_PER_USER_EXCEEDED = 'SIMULTANEOUS_SESSIONS_PER_USER_EXCEEDED',
    SIMULTANEOUS_SESSIONS_PER_COMPANY_EXCEEDED = 'SIMULTANEOUS_SESSIONS_PER_COMPANY_EXCEEDED',
    NO_COMPANY_LICENSE = 'NO_COMPANY_LICENSE',
    NO_USER_LICENSE = 'NO_USER_LICENSE',
}
